import { useState, useEffect, useCallback } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import { API_URL } from '../constants';
import { __ } from '@wordpress/i18n';
import { addQueryArgs } from '@wordpress/url';

const useCurrencies = () => {
	const [ currencies, setCurrencies ] = useState( [] );
	const [ prevCurrencies, setPrevCurrencies ] = useState( [] );
	const [ coreCurrencies, setCoreCurrencies ] = useState( [] );
	const [ status, setStatus ] = useState( null );
	const [ isLoading, setIsLoading ] = useState( false );

	const fetchCurrencies = useCallback( async ( getGFCurrencies = false ) => {
		setIsLoading( true );

		const url = getGFCurrencies
			? addQueryArgs( API_URL, { core_gf_currencies:1 } )
			: API_URL;

		try {
			const response = await apiFetch( {
				path: url,
			} );

			const currenciesArray = Object.values( response );

			if ( Array.isArray( currenciesArray ) && currenciesArray.length ) {
				if ( getGFCurrencies ) {
					setCoreCurrencies( currenciesArray );
				} else {
					setCurrencies(currenciesArray);
					setPrevCurrencies(currenciesArray);
				}
			} else {
				console.error(
					'Invalid data received from the API:',
					currenciesArray
				);
			}
		} catch ( err ) {
			setStatus( err );
		} finally {
			setIsLoading( false );
		}
	}, [prevCurrencies] );

	const saveCurrencies = useCallback( async ( updatedCurrencies ) => {
		
		if (
			JSON.stringify( prevCurrencies ) ===
			JSON.stringify( updatedCurrencies )
		) {
			alert( __( 'No changes to save', 'currency-manager-for-gravity-forms' ) );
			return;
		}
		setIsLoading( true );
		setStatus( null );

		try {
			const response = await apiFetch( {
				path: API_URL,
				method: 'POST',
				data: {
					currencies: updatedCurrencies,
				},
			} );

			if ( response.success ) {
				setStatus( 'success' );
				setPrevCurrencies( updatedCurrencies );
			}
		} catch ( err ) {
			setStatus( err );
		} finally {
			setIsLoading( false );
		}
	}, [prevCurrencies] );

	useEffect(() => {
		const loadCurrencies = async () => {
			setIsLoading(true);
			try {
				await Promise.all([fetchCurrencies(), fetchCurrencies(true)]);
			} finally {
				setIsLoading(false);
			}
		};
		loadCurrencies();
	}, []);

	return {
		currencies,
		prevCurrencies,
		fetchCurrencies,
		saveCurrencies,
		setCurrencies,
		coreCurrencies,
		isLoading,
		setIsLoading,
		status,
		setStatus,
	};
};

export default useCurrencies;
